import ProfitAndLoss from "../../Components/Reports/ProfitAndLoss";
import CashFlow from "../../Components/Reports/CashFlow";
import BalanceSheet from "../../Components/Reports/BalanceSheet";
import BalanceSheetAnalysis from "../../Components/Reports/BalanceSheetAnalysis";
import AnalyticalLayers from "../../Components/Reports/AnalyticalLayers";
import StructuralRatios from "../../Components/Reports/StructuralRatios";
import TimeSeriesCommonSize from "../../Components/Reports/TimeSeriesCommonSize";
import TrialBalanceReport from "../../Components/Reports/TrialBalanceReport";
import {
  FaBalanceScale,
  FaCalculator,
  FaChartBar,
  FaChartLine,
  FaChartPie,
  FaFileInvoiceDollar,
  FaReceipt,
} from "react-icons/fa";

const normalizeLocalizedText = (value, language, fallback) => {
  if (typeof value === "string") {
    return value;
  }

  if (typeof value === "number") {
    return String(value);
  }

  if (value && typeof value === "object") {
    const isArabic = language === "Arabic" || language === "ar";
    const preferredValue = isArabic ? value.ar ?? value.AR : value.en ?? value.EN;

    if (typeof preferredValue === "string" && preferredValue.trim()) {
      return preferredValue;
    }

    const firstStringValue = Object.values(value).find(
      (item) => typeof item === "string" && item.trim()
    );

    if (firstStringValue) {
      return firstStringValue;
    }
  }

  return fallback;
};

const REPORT_COMPONENTS = {
  Wafeq_trial_balance: TrialBalanceReport,
  Wafeq_balance_sheet: BalanceSheet,
  Wafeq_cash_flow: CashFlow,
  Wafeq_profit_and_loss: ProfitAndLoss,
  Wafeq_time_series_common_size: TimeSeriesCommonSize,
  Wafeq_structural_ratios: StructuralRatios,
  Wafeq_analytical_layers: AnalyticalLayers,
  Wafeq_intra_category_analysis: BalanceSheetAnalysis,
};

const REPORT_ICONS = {
  Wafeq_trial_balance: FaFileInvoiceDollar,
  Wafeq_balance_sheet: FaBalanceScale,
  Wafeq_cash_flow: FaReceipt,
  Wafeq_profit_and_loss: FaFileInvoiceDollar,
  Wafeq_time_series_common_size: FaChartLine,
  Wafeq_structural_ratios: FaChartBar,
  Wafeq_analytical_layers: FaChartPie,
  Wafeq_intra_category_analysis: FaCalculator,
};

const REPORT_TEXT_KEYS = {
  Wafeq_trial_balance: ["trialBalance", "trialBalanceAr", "Trial Balance", "ميزان المراجعة"],
  Wafeq_balance_sheet: ["balanceSheet", "balanceSheetAr", "Balance Sheet", "الميزانية العمومية"],
  Wafeq_cash_flow: ["cashFlow", "cashFlowAr", "Cash Flow", "التدفق النقدي"],
  Wafeq_profit_and_loss: ["profitAndLoss", "profitAndLossAr", "Profit and Loss", "قائمة الدخل"],
  Wafeq_time_series_common_size: [
    "timeSeriesCommonSize",
    "timeSeriesCommonSizeAr",
    "Time Series Common Size",
    "تحليل القوائم المالية الموحدة عبر الزمن",
  ],
  Wafeq_structural_ratios: ["structuralRatios", "structuralRatiosAr", "Structural Ratios", "النسب الهيكلية"],
  Wafeq_analytical_layers: ["analyticalLayers", "analyticalLayersAr", "Analytical Layers", "الطبقات التحليلية"],
  Wafeq_intra_category_analysis: [
    "intraCategoryAnalysis",
    "intraCategoryAnalysisAr",
    "Intra Category Analysis",
    "تحليل الفئة الداخلية",
  ],
};

export const getReportComponent = (reportKey) => REPORT_COMPONENTS[reportKey] || null;

export const getReportIcon = (reportKey) =>
  REPORT_ICONS[reportKey] || FaFileInvoiceDollar;

export const getReportDisplayName = (reportKey, reportsTexts, language) => {
  const keys = REPORT_TEXT_KEYS[reportKey];
  if (!keys) {
    return reportKey.replace("Wafeq_", "").replace(/_/g, " ");
  }

  const isArabic = language === "Arabic" || language === "ar";
  const value = isArabic ? reportsTexts?.[keys[1]] : reportsTexts?.[keys[0]];
  const fallback = isArabic ? keys[3] : keys[2];

  return normalizeLocalizedText(value, language, fallback);
};
